export const StatusPageRouteNames = {
  STATUS_PAGE: 'statuspage',
};

export const StatusPageTabs = {
  OPEN: 'open',
  INCIDENTS: 'incidents',
};

export const RESOLVED_STATUS = 'resolved';

export const STATUS_LABELS = {
  investigating: 'Investigating',
  identified: 'Identified',
  monitoring: 'Monitoring',
  resolved: 'Resolved',
  scheduled: 'Scheduled',
  in_progress: 'In Progress',
  verifying: 'Verifying',
  completed: 'Completed',
  postmortem: 'Postmortem',
};

export const IMPACT_LABELS = {
  none: 'No Impact',
  minor: 'Minor',
  major: 'Major',
  critical: 'Critical',
};

export const STATUS_CLASS_MAP = {
  investigating: 'has-text-warning has-background-warning-light',
  identified: 'has-text-danger has-background-danger-light',
  monitoring: 'has-text-info has-background-info-light',
  resolved: 'has-text-success has-background-success-light',
  in_progress: 'has-text-warning has-background-warning-light',
  verifying: 'has-text-info has-background-info-light',
  completed: 'has-text-success has-background-success-light',
  postmortem: 'has-background-purple',
};

export const IMPACT_CLASS_MAP = {
  none: 'has-text-success has-background-success-light',
  minor: 'has-text-warning has-background-warning-light',
  major: 'has-text-danger has-background-danger-light',
  critical: 'has-text-danger has-background-danger-light',
};

export const DEFAULT_TAG_CLASS = 'tag is-light';

export const IncidentBadgeVariant = {
  STATUS: 'status',
  IMPACT: 'impact',
};
